export const dserverIp = "https://server.abrahammensah.com";
export const dclientIp = "https://abrahammensah.com";
export const serverIp = "https://roomadvisor.io/api";
export const clientIp = "https://roomadvisor.io";
export const cryptoKey = "1234";
